module.exports = __webpack_public_path__ + "img/ug.a27dcf17.png";